var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('a',{attrs:{"href":_vm.field.link,"target":"_blank"}},[_c('v-btn',{staticStyle:{"text-transform":"none"},attrs:{"rounded":"","color":"primary","dark":""}},[_vm._v(" "+_vm._s(_vm.field.name)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }